var map = {
	"./addliquidity.json": 1266,
	"./box.json": 1267,
	"./components.json": 1268,
	"./constants.json": 1269,
	"./error.json": 1270,
	"./game.json": 1271,
	"./home.json": 1272,
	"./lottery.json": 1273,
	"./menu.json": 1274,
	"./nft.json": 1275,
	"./prediction.json": 1276,
	"./uikit.json": 1277
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1265;